import "./components/_scaleRoot";
$(".inner").scaleRoot({
    scaleMode: (viewportIsMobile($("body").outerWidth())) ? 'containWidth' : 'cover'
});

// $(".inner:not(.detect-iframe > .outer > #scrollContent, .popup-sn2020 .inner)").scaleRoot({
//     scaleMode: (viewportIsMobile($("body").outerWidth())) ? 'containWidth' : 'cover'
// });



function viewportIsMobile(width) {
    return (width < 1025);
}

import "./components/_lightbox";



import MobileDetect from "mobile-detect"

var md = new MobileDetect(window.navigator.userAgent);


if ($(".getLink").length > 0) {

    switch (md.os()) {
        case 'AndroidOS':
            $(".getLink").addClass("open-download-and");
            $(".open-download-and").click(function (e) {
                e.preventDefault();

                $(".popup--download-android").addClass("active");
            });
            break;
        case 'iOS':
            $(".getLink").attr("href", $(".getLink-ios").attr("href"));
            break;
        default:
    }

}
$(document).ready(function () {
    init_stickybar();
    activeCakeFrame1();
    // if (isMobile.any()) {
    //     $('#floating .nav-top-mb').removeClass('nav-top-promotion');
    // } else {
    //     $('#floating .nav-top-promotion').removeClass('nav-top-mb');
    // }
    $("#navigation li").hover(
        function (event) {
            $(this).find(".submenu").show();
        },
        function (event) {
            $(this).find(".submenu").hide();
        }
    );
});




var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Desktop: function () {
        return navigator.userAgent.match(/Windows NT/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};
var IsOpen = false;
$(".opennav").on("click", function (e) {
    e.preventDefault();
    if (!IsOpen) {
        $(".sub-nav-mb").addClass("Open");
        $(".opennav").addClass("toclose is-active");
        IsOpen = true;
    }
    else {
        $(".sub-nav-mb").removeClass("Open");
        $(".opennav").removeClass("toclose is-active");
        IsOpen = false;
    }
});

function init_stickybar() {
    if ($('.aside-right').length > 0) {
        $(".aside-right .bt-control").click(function () {
            if ($(this).hasClass("close")) {
                $(".aside-right").addClass('closeAsideright');
                $('.bt-control').removeClass("close").addClass('open');
            } else {
                $(".aside-right").removeClass('closeAsideright');
                $('.bt-control').removeClass("open").addClass("close");
            }
            return false;
        })
        if ($(window).outerWidth() < 1600) {
            $(".aside-right .bt-control").trigger("click");
        }
    }
}


function activeCakeFrame1() {
    if ($('.banhsinhnhat').length > 0) {
        $.ajax("https://event.zing.vn/webapi/getTotalUsedPoint?apiKey=APIKEY_6a4f5cd1ac697080b8cb178c82cf740f&programID=270&sig=bef6e1674beef97127df1293348900f4")
            .done(function (data) {
                console.log(data);
                if (data) {
                    var totalReg = parseInt(data.data);
                    $('.number-reg span').html(totalReg);
                    var indexActive = 0;
                    if (totalReg >= 100000) {
                        indexActive++;
                    }
                    if (totalReg >= 150000) {
                        indexActive++;
                    }
                    if (totalReg >= 200000) {
                        indexActive++;
                    }
                    if (totalReg >= 50000) {
                        indexActive++;
                        for (var i = 0; i < indexActive; i++) {
                            $('.banhsinhnhat li').eq(i).addClass('active');
                        }
                    }
                }
            })
            .fail(function () {
                console.log("error");
            });
    }
}
window.activeCakeFrame1 = activeCakeFrame1;
import "./components/_content-tab";
// import "./components/_frame-mp";
// import "./components/_control-side";
// import "./components/_progress";
import "./components/_watchIFrame";
